import Vue from "vue";
import Router from "vue-router";
import { ErrorHandler, RawLocation, Route } from "vue-router/types/router";
import { routes } from "./routes";

export class RouterSafe extends Router {
  public push(location: RawLocation): Promise<Route>;
  public push(location: RawLocation, onComplete?: () => void, onAbort?: ErrorHandler): Promise<Route> | void {
    if (onComplete || onAbort) {
      return super.push(location, onComplete, onAbort);
    }
    return super.push(location).catch(e => {
      if (e.message.toLowerCase().includes("navigation guard")) {
        return this.currentRoute;
      } else throw e;
    });
  }

  public replace(location: RawLocation): Promise<Route>;
  public replace(location: RawLocation, onComplete?: () => void, onAbort?: ErrorHandler): Promise<Route> | void {
    if (onComplete || onAbort) {
      return super.replace(location, onComplete, onAbort);
    }
    return super.replace(location).catch(e => {
      if (e.message.toLowerCase().includes("navigation guard")) {
        return this.currentRoute;
      } else throw e;
    });
  }
}
Vue.use(RouterSafe);

export default new RouterSafe({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// todo: если планируешь добавить scrollBehaviour, то помни что в PageProfile окно прокручивается к началу в методе getProfileData
